import { useNavigate } from 'react-router-dom';
import { OutlineButton } from '../../components';
import { style } from './error-page.module.css';
import { WhatsappIcon } from '../../icons/whatsapp.icon';

interface Props {
  image: string;
  onClick?: () => void;
}

export function ErrorPage(props: Props) {

  const { 
    image,
    onClick
  } = props;

  const navigate = useNavigate();

  function handleClick() {
    navigate('/');
    onClick?.();
  }

  return (
    <div className={style.container}>
      <img className={style.image} src={image}/>
      <h1 className={style.title}>Ocurrió un error</h1>
      <p className={style.description}>
        Asegúrese de estar conectado a internet e inténtelo de nuevo.
      </p>
      <p className={style.description}>
        Si el problema persiste, contáctenos:
        <a href="https://wa.me/18298711132" target="_blank" rel="noopener noreferrer" className={style.whatsappLink}>
          <WhatsappIcon className={style.whatsappIcon}/>
          <strong>(829) 871-1132</strong>
        </a>
      </p>
      <OutlineButton 
        style={style.button}
        text='Actualizar'
        onClick={handleClick}/>
    </div>
  );
}
